<template>
  <v-layout row>
    <v-flex xs12 md10 offset-md1>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-subheader>Requesting user</v-subheader>
        </v-flex>
        <v-flex xs12 md8>
          <div class="data-display">{{ request.user.name }}</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-subheader>Status</v-subheader>
        </v-flex>
        <v-flex xs12 md8>
          <div class="data-display">{{ request.status }}</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-subheader>Approvers</v-subheader>
        </v-flex>
        <v-flex xs12 md8>
          <ul class="approvers-list data-display">
            <li v-for="approver in request.approvers">
              <strong v-if="approver.aoid === user.sub">{{ approver.name }}</strong>
              <template v-else>{{ approver.name }}</template>
            </li>
          </ul>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-subheader>Created date</v-subheader>
        </v-flex>
        <v-flex xs12 md8>
          <div class="data-display">{{ createdDate }}</div>
        </v-flex>
      </v-layout>
      <v-layout row class="buffer">
        <v-flex xs12>
          <token-manager :value="request.scopes" :options="options"/>
        </v-flex>
      </v-layout>
      <template v-if="request.status !== 'PENDING'">
        <div class="rule"></div>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-subheader>{{ labelStatus }} by</v-subheader>
          </v-flex>
          <v-flex xs12 md8>
            <div class="data-display">{{ request.closedBy.name }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-subheader>{{ labelStatus }} date</v-subheader>
          </v-flex>
          <v-flex xs12 md8>
            <div class="data-display">{{ closedDate }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="request.closedReason">
          <v-flex xs12 md4>
            <v-subheader>Reason</v-subheader>
          </v-flex>
          <v-flex xs12 md8>
            <div class="data-display">{{ request.closedReason }}</div>
          </v-flex>
        </v-layout>
      </template>
      <v-layout row>
        <v-flex xs12 class="buttonContainer">
          <v-btn @click="goBack">Back</v-btn>
          <template v-if="request.status === 'PENDING'">
            <template v-if="isApprover">
              <v-btn color="success" @click="openApprove">Approve</v-btn>
              <v-btn color="error" @click="openReject">Reject</v-btn>
            </template>
            <v-btn v-if="request.user.aoid === user.sub" color="warning"
                   @click="openCancel">
              Cancel
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog v-model="showModal" max-width="750px">
      <v-card>
        <v-card-text>
          <v-text-field v-model="closedReason" label="Reason"/>
          <v-btn :color="closeButton.color" @click="completeRequest" :disabled="sendingResponse">
            {{ closeButton.label }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import util from '../../util';
  import { mapState, mapActions } from 'vuex';
  import TokenManager from '@/views/shared/jwtservices/TokenManager';

  export default {
    props: {
      userId: String,
      created: String // Technically a long in java but it's not really important here
    },
    components: { TokenManager },
    data() {
      return {
        request: {
          user: {},
          approvers: [],
          scopes: {},
          closedBy: {},
          status: ''
        },
        showModal: false,
        responseMode: null,
        closedReason: null,
        sendingResponse: false,
        options: ['request']
      };
    },
    computed: {
      createdDate() {
        return new Date(this.request.created).toString();
      },
      closedDate() {
        return new Date(this.request.closed).toString();
      },
      labelStatus() {
        return this.request.status[0] + this.request.status.substr(1).toLowerCase();
      },
      isApprover() {
        return this.request.approvers.map((approver) => approver.aoid)
          .indexOf(this.user.sub) > -1;
      },
      closeButton() {
        switch (this.responseMode) {
          case 'APPROVED':
            return { color: 'success', label: 'Approve' };
          case 'REJECTED':
            return { color: 'error', label: 'Reject' };
          default:
            return { color: 'warning', label: 'Cancel' };
        }
      },
      ...mapState('auth', [
        'user'
      ])
    },
    methods: {
      getRequest() {
        this.$services.authenticator.get(`/approvals/requests/${this.userId}/${this.created}`)
          .then((response) => this.request = response.data.data)
          .catch(this.$defaultHandlerHttp);
      },
      goBack: util.goBack('/approvals'),
      openApprove() {
        this.responseMode = 'APPROVED';
        this.showModal = true;
      },
      openReject() {
        this.responseMode = 'REJECTED';
        this.showModal = true;
      },
      openCancel() {
        this.responseMode = 'CANCELLED';
        this.showModal = true;
      },
      completeDetails() {
        switch (this.responseMode) {
          case 'APPROVED':
            return { endpoint: 'approve', label: 'approved' };
          case 'REJECTED':
            return { endpoint: 'reject', label: 'rejected' };
          default:
            return { endpoint: 'cancel', label: 'cancelled' };
        }
      },
      completeRequest() {
        const complete = this.completeDetails();
        this.sendingResponse = true;
        this.$services.authenticator.post(
          `/approvals/requests/${this.userId}/${this.created}/${complete.endpoint}`,
          {
            reason: this.closedReason ? this.closedReason : null
          }
        ).then(() => {
          this.show(`Request successfully ${complete.label}`);
          this.showModal = false;
          this.sendingResponse = false;
        }).then(() => this.getRequest())
          .catch(this.$defaultHandlerHttp);
      },
      ...mapActions('alert', [
        'show'
      ])
    },
    mounted() {
      this.getRequest();
    }
  };
</script>

<style lang="less" scoped>
  @import '../../style/form.less';

  ul.approvers-list {
    list-style: none;
    text-align: left;
    display: block;

    li {
      display: block;
    }
  }
</style>
